import { type FC, useLayoutEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { Button, type ButtonProps } from '@/components/common/button/Button';
import { Spinner } from '@/components/common/Spinner';
import { useElementSize } from '@/hooks/use-element-size';
import { usePrevious } from '@/hooks/use-previous';

export type FormSubmitButtonProps = Omit<ButtonProps, 'type'> & {
  saveWidth?: boolean;
};

export const FormSubmitButton: FC<FormSubmitButtonProps> = (props) => {
  const { className, style, children, saveWidth = true, iconLeft, ...buttonProps } = props;

  const [buttonWidth, setButtonWidth] = useState<number | string>('');

  const {
    formState: { isSubmitting },
  } = useFormContext();

  const {
    ref,
    size: { width: calculatedButtonWidth },
  } = useElementSize();

  const prevIsSubmitting = usePrevious(isSubmitting);

  useLayoutEffect(() => {
    if (isSubmitting && !prevIsSubmitting) {
      setButtonWidth(calculatedButtonWidth);
    } else if (!isSubmitting && prevIsSubmitting) {
      setButtonWidth('');
    }
  }, [calculatedButtonWidth, isSubmitting, prevIsSubmitting]);

  return (
    <Button
      {...buttonProps}
      className={className}
      ref={ref}
      type="submit"
      disabled={buttonProps.disabled || isSubmitting}
      iconLeft={isSubmitting ? null : iconLeft}
      style={
        saveWidth && buttonWidth
          ? {
              ...style,
              width: isSubmitting ? buttonWidth : undefined,
            }
          : style
      }
    >
      {isSubmitting ? <Spinner /> : children}
    </Button>
  );
};
